import Vue from 'vue';
import { get, sync } from 'vuex-pathify';
import { mapActions } from 'vuex';
import { Group } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib/types/model/userData';
import { authProvider } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib';
import { wrapInArray } from '@/utils/helpers';

export default Vue.extend({
  name: 'auth-mixin',

  computed: {
    changed: sync('auth/passwordChanged'),
    getLoading: get('accounts/getLoading'),
    getAuthError: get('auth/getAuthError'),
    getAppUserInfo: get('auth/getUser'),
    getCurrentUser: get('accounts/getCurrentUser'),
    getCurrentUserFullName: get('auth/getFullName'),

    authProvider(): any {
      return authProvider(this.$store);
    },

    currentUser(): any {
      return this.authProvider.getCurrentUser;
    },

    isUserQuoteAdmin(): boolean {
      return this.userHasRoles('Quote Admin');
    },

    isUserRequisitionAdmin(): boolean {
      return this.userHasRoles('Purchase Requisition Admin');
    },

    isUserInventoryAdvancePaymentAdmin(): boolean {
      return this.userHasRoles('Inventory Advance Payment Admin');
    },

    isUserInventoryAdvancePaymentVendorEditor(): boolean {
      return this.userHasRoles('Inventory Advance Payment Vendor Editor');
    },

    isUserPaymentRequisitionAdmin(): boolean {
      return this.userHasRoles('Payment Requisition Admin');
    },

    isUserPaymentRequisitionVendorEditor(): boolean {
      return this.userHasRoles('Payment Requisition Vendor Editor');
    },

    isUserPayrollChangeRequestAdmin(): boolean {
      return this.userHasRoles('Payroll Change Request Admin');
    },

    isUserPayrollChangeRequestReviewer(): boolean {
      return this.userHasRoles('Payroll Change Request Reviewer');
    },

    isUserHRPersonnel(): boolean {
      return this.userHasRoles('HR Personnel');
    },

    isUserSupervisor(): boolean {
      return this.userHasRoles('Supervisor');
    },

    isUserPOBuyer(): boolean {
      return this.userHasRoles('PO Buyer');
    },

    // TODO: LH - 2022-12-22 - let's look into just using the `userHasRoles` method to check permissions
    isUserTimeOffReviewer(): boolean {
      return this.userHasRoles('Time Off Reviewer');
    }
  },
  methods: {
    ...mapActions({
      passwordConfirm: 'auth/passwordConfirm',
      passwordResetConfirm: 'auth/passwordResetConfirm',
      forgotPassword: 'auth/forgotPassword',
      verifyEmail: 'auth/verifyEmail',
      requestEmail: 'auth/requestEmail',
      logout: 'auth/logout',
      login: 'auth/login',
      clearError: 'auth/clearError'
    }),

    userHasRoles(authRoles: string | string[]): boolean {
      const userGroups: Group[] = this.authProvider.getCurrentUser.groups;

      //there are cases where the userGroup becomes undeined with causes '.some()' to be unaccessable
      if (!userGroups) return false;

      const userHasRole = userGroups.some(group =>
        wrapInArray(authRoles).includes(group.name!)
      );
      return userHasRole || this.authProvider.isUserAdmin;
    },

    userHasPermissions(permissions: string[]): boolean {
      return permissions.some(permission =>
        this.authProvider.hasPermission(permission)
      );
    }
  }
});
